import { memo, useCallback, useState } from 'react';
import { Text, View, ScrollView } from 'react-native';
import { THEME, COLOR } from '../../constants/styles';
import HeaderItem from './header_item';
import Utils from '../../utils';

const DataTableRow = memo(function (props) {
  const altColorStyle =
    props.altColors && props.rowIndex % 2 === 1 ? { backgroundColor: COLOR.altContrast } : null;
  function renderColumnData(c, i) {
    const dataAccessor = c.dataAccessor;
    const contents =
      typeof dataAccessor === 'function' ? (
        dataAccessor(props.row)
      ) : (
        <Text style={[THEME.rowText, c.extraRowTextStyle]}>{props.row[dataAccessor]}</Text>
      );
    return (
      <View key={c.headerLabel} style={[THEME.rowColumn, c.style, c.extraRowStyle]}>
        {contents}
      </View>
    );
  }

  if (props.renderRowHeader) {
    return (
      <View style={[THEME.basicColumn, altColorStyle]}>
        {props.renderRowHeader(props.row, props.rowIndex)}
        <View style={[THEME.basicRow]}>{props.columns.map(renderColumnData)}</View>
      </View>
    );
  }

  return <View style={[THEME.basicRow, altColorStyle]}>{props.columns.map(renderColumnData)}</View>;
});
export default memo(function (props) {
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDir, setSortDir] = useState(1);

  const handleSortColumn = useCallback(
    (column) => {
      setSortColumn((prevSortColumn) => {
        if (prevSortColumn === column) {
          setSortDir((prevSortDir) => prevSortDir * -1);
        } else {
          setSortDir(props.defaultSortDirsPerColumn?.[column] ?? 1);
        }
        return column;
      });
    },
    [props.defaultSortDirsPerColumn]
  );

  function renderRow(rowData, i) {
    return (
      <DataTableRow
        key={rowData.key}
        row={rowData}
        columns={props.columns}
        rowIndex={i}
        altColors={props.altColors}
        renderRowHeader={props.rowHeaderRenderer}
      />
    );
  }
  function renderColumnHeader(c, i, arry) {
    const lastColStyle = i === arry.length - 1 ? { borderRightWidth: 0 } : null;
    if (typeof c.headerLabel === 'function') {
      return (
        <View key={i} style={[THEME.sectionHeaderColumn, c.style, lastColStyle]}>
          {c.headerLabel()}
        </View>
      );
    }
    // const headerLabelContents =
    //   typeof c.headerLabel === 'function' ? (
    //     c.headerLabel()
    //   ) : (
    //     <Text style={THEME.sectionHeaderText}>{c.headerLabel}</Text>
    //   );
    // return (
    //   <View key={i} style={[THEME.sectionHeaderColumn, c.style, lastColStyle]}>
    //     {headerLabelContents}
    //   </View>
    // );

    return (
      <HeaderItem
        key={i}
        label={c.headerLabel}
        style={[THEME.sectionHeaderColumn, c.style, lastColStyle]}
        onPress={c.sortProp ? handleSortColumn : null}
        name={c.sortProp}
        sortColumn={sortColumn}
        sortDir={sortDir}
        left={true}
      />
    );
  }

  const sortFields = [sortColumn];
  const sortOrder = [sortDir > 0 ? 'asc' : 'desc'];
  const sortedData = props.sortable ? Utils.orderBy(props.data, sortFields, sortOrder) : props.data;

  return (
    <View style={{ flex: 1 }}>
      <ScrollView
        stickyHeaderIndices={[0]}
        keyboardShouldPersistTaps="handled"
        alwaysBounceVertical={false}
        keyboardDismissMode="on-drag"
      >
        <View key="header">
          <View style={THEME.sectionHeader}>{props.columns?.map(renderColumnHeader)}</View>
        </View>
        {sortedData?.map(renderRow)}
      </ScrollView>
    </View>
  );
});
